import React from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { IMicroservice, IMicroservicesDataTableProps } from '../Microservices.types';

const MicroservicesDataTable = (props: IMicroservicesDataTableProps): JSX.Element => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>API Id</th>
                    <th>API Name</th>
                    <th></th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.data && props.data.map((value: IMicroservice, index: number) => {
                    return (
                        <tr key={`row-${index}`}>
                            <td key={`microservice-id-${index}`}>{value.id}</td>
                            <td key={`microservice-name-${index}`}>{value.microserviceName}</td>
                            <td key={`microservice-editCol-${index}`}>
                                <Button
                                    variant='secondary'
                                    onClick={_ => props.onEdit(value.id)}
                                    >
                                    Edit
                                </Button>
                            </td>
                            <td key={`microservice-deleteCol-${index}`}>
                                <Button
                                    variant='danger'
                                    onClick={_ => props.onDelete(value.id)}
                                    >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default MicroservicesDataTable;